import { render, staticRenderFns } from "./FormPanel.vue?vue&type=template&id=237767b9&"
import script from "./FormPanel.vue?vue&type=script&lang=ts&"
export * from "./FormPanel.vue?vue&type=script&lang=ts&"
import style0 from "./FormPanel.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports